<template lang="pug">
  v-layout(align-start)
    v-flex
      v-app-bar(dark color='primary')
        v-toolbar-title.head-view VALOR DE INVENTARIO
      v-card
        v-row(dense)
          v-col(cols='12')
              v-card-subtitle.title(style='color: black; padding: 16px 16px 0px 16px;') Almacen
              v-row.mx-2
                v-col(cols='6' sm='12' md='6')
                  v-autocomplete( autocomplete="off" v-model='almacenSelec' dense outlined label="Seleccione su almacen" :items="almacenes" @change="listarProductos" loading-text='Cargando, por favor espere...')
                v-col(cols='6' sm='12' md='6')
                  v-select(v-model='sortBy' dense outlined label="Ordenar productos por.." :items="sort" @change="ordenarProductos" :disabled='!validador')
              v-data-table.elevation-6.mx-3(:headers='headers' :items='productos' :loading='loading' :search='search')
                template(v-slot:top)
                    v-toolbar(flat='' color='primary' dark='')
                      v-flex(class="d-flex flex-wrap justify-center")
                        v-toolbar-title Productos
                        v-divider.mx-4(inset='' vertical='')
                        v-spacer
                        v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                      v-spacer
                      //-     div(style='text-align: right;font-size: 18px;font-weight: bold;')
                      //-         span {{'TOTAL: '+ total}}
                template(v-slot:no-data)
                  h2.pa-2 No existen productos en el almacen
        v-row(dense)
            v-card-text(style='text-align: center;font-size: 18px;font-weight: bold;')
                span(style="color: black;") TOTAL:
                span(style="color: green;") {{' '+ total}}
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    loading: false,
    almacenes: [],
    almacenSelec: null,
    productos: [],
    total: 0,
    search: '',
    sortBy: '',
    sort: ['Stock', 'Valor Unitario', 'Valor Total'],
    validador: false,
    headers: [
      {
        text: 'Codigo',
        align: 'left',
        sortable: false,
        value: 'idProducto.nombre'
      },
      {
        text: 'Nombre',
        align: 'left',
        sortable: false,
        value: 'idProducto.descripcion'
      },
      { text: 'Stock', align: 'center', sortable: false, value: 'cantidad' },
      {
        text: 'Valor Unitario',
        align: 'center',
        sortable: false,
        value: 'precioShow'
      },
      {
        text: 'Valor Total',
        align: 'center',
        sortable: false,
        value: 'precioTotalShow'
      }
    ]
  }),

  created () {
    this.listarAlmacenes()
  },
  methods: {
    formatoDecimal (i) {
      let n = parseFloat(i).toFixed(2)
      return Number(n).toLocaleString(
        'es-US',
        { style: 'currency', currency: 'USD' },
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      )
    },
    listarAlmacenes () {
      Api.get('almacen')
        .then(response => {
          response.data.map(almacen => {
            this.almacenes.push({
              value: almacen._id,
              text: almacen.descripcion
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarProductos (idAlmacen) {
      this.validador = true
      this.loading = true
      this.productos = []
      this.total = 0
      Api.get('proalma/valorStock/' + idAlmacen)
        .then(response => {
          this.loading = false
          this.productos = response.data
          // console.log(this.productos)
          this.productos.map(data => {
            data.precioTotal = data.cantidad * data.precio
            this.total += data.precioTotal
            data.precioShow = this.formatoDecimal(data.precio)
            data.precioTotalShow = this.formatoDecimal(data.precioTotal)
          })
          this.total = this.formatoDecimal(this.total)
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    ordenarProductos (val) {
      switch (val) {
        case 'Stock':
          this.productos.sort((a, b) => (a.cantidad < b.cantidad) ? 1 : -1)
          break
        case 'Valor Unitario':
          this.productos.sort((a, b) => (a.precio < b.precio) ? 1 : -1)
          break
        case 'Valor Total':
          this.productos.sort((a, b) => (a.precioTotal < b.precioTotal) ? 1 : -1)
          break
      }
    }
  }
}
</script>
<style lang="scss">
.head-view {
  font-size: 1.5rem;
}
@media screen and (max-width: 425px) {
  .head-view {
    font-size: 1rem;
  }
}
</style>
